<script setup lang="ts">
import { PhCheck, PhMonitorPlay, PhStudent } from '@phosphor-icons/vue'

defineProps<{ studentImageUrl: string; classroomImageUrl: string }>()
</script>

<template>
  <section id="scenes" class="learning-scenes">
    <div class="scene-block scene-student">
      <div class="scene-content">
        <div class="scene-heading">
          <PhStudent :size="27" weight="duotone" />
          <h2>自主学习</h2>
        </div>
        <p>课前预习、课后巩固，把抽象知识转化为可以反复验证的过程。</p>
        <ul>
          <li><PhCheck :size="17" weight="bold" /> 理解抽象概念</li>
          <li><PhCheck :size="17" weight="bold" /> 验证科学规律</li>
          <li><PhCheck :size="17" weight="bold" /> 培养探究能力</li>
        </ul>
      </div>
      <img v-if="studentImageUrl" :src="studentImageUrl" alt="观察液体扩散过程" loading="lazy" />
      <div v-else class="image-placeholder scene-image-placeholder">自主学习场景图</div>
    </div>

    <div class="scene-block scene-classroom">
      <div class="scene-content">
        <div class="scene-heading">
          <PhMonitorPlay :size="27" weight="duotone" />
          <h2>课堂演示</h2>
        </div>
        <p>快速呈现实验现象，降低准备成本，让课堂讲解更直观、更聚焦。</p>
        <ul>
          <li><PhCheck :size="17" weight="bold" /> 与章节进度同步</li>
          <li><PhCheck :size="17" weight="bold" /> 现象清晰可观察</li>
          <li><PhCheck :size="17" weight="bold" /> 支持重复验证</li>
        </ul>
      </div>
      <img v-if="classroomImageUrl" :src="classroomImageUrl" alt="磁场现象演示" loading="lazy" />
      <div v-else class="image-placeholder scene-image-placeholder">课堂演示场景图</div>
    </div>
  </section>
</template>
